import Dialog from "../common/Dialog";

const GuideConfirmationDialog = ({
  id,
  title,
  children,
  confirmLabel,
  confirmClassName = "hms-gray-btn",
  busy = false,
  onCancel,
  onConfirm,
  closeLabel = "Close confirmation",
}) => (
  <Dialog id={id}>
    <div className="uk-modal-dialog uk-modal-body">
      <button
        className="uk-modal-close-default"
        type="button"
        uk-close="true"
        aria-label={closeLabel}
        disabled={busy}
      />
      <h2 className="uk-modal-title">{title}</h2>
      <div>{children}</div>
      <p className="uk-text-right">
        <button
          className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
          type="button"
          disabled={busy}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className={`uk-button hms-btn ${confirmClassName}`}
          type="button"
          disabled={busy}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </p>
    </div>
  </Dialog>
);

export default GuideConfirmationDialog;
